import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ModalGenericoModel } from 'src/app/shared/models/modal.model';
import { EstablecimientoEntry } from 'src/app/shared/entrys/establecimiento.entry';
import { Router } from '@angular/router';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';
import { PrestadorModel } from 'src/app/shared/models/prestador.model';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { AuthService } from 'src/app/shared/services/auth.service';
import { TipoPrestador } from 'src/app/shared/enumeraciones/tipo-prestador.enum';

@Component({
	selector: 'app-modal-editar-perfil',
	templateUrl: './modal-editar-perfil.component.html',
	styleUrls: ['./modal-editar-perfil.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalEditarPerfilComponent implements OnInit {
	@Input()
	prestadorModel: PrestadorModel;
	@Input()
	onlyPassword?: boolean = false;
	@Input()
	closeable: boolean = true;
	
	tipo_prestador = RolesUsuario.Prestador;
	tipo_prestador_no_comerciante = TipoPrestador.Guia;
	headers: Array<string>;
	modalGenerico: ModalGenericoModel;
	formDatosBasicos: FormGroup;
	formCambiarContrasena: FormGroup;
	constructor(private activeModal: NgbActiveModal, public authService: AuthService,
		private formBuilder: FormBuilder, private modalService: NgbModal,private dataSharedService: DataSharedService) {
	}

	ngOnInit() {
		this.modalGenerico = {
			titulo: 'Editar perfil'
		};
		this.headers = ['Código', 'Descripción'];
		this.formDatosBasicos = this.formBuilder.group({
			patrimonio_neto: [this.prestadorModel.patrimonio_neto, [ConfirmeValidators.numberNegativeValidator, Validators.max(999999999999999)]],
			correo_electronico: [this.prestadorModel.correo_electronico,
			[ConfirmeValidators.emailValidator]],
			telefono_reportado_1: [this.prestadorModel.telefono_reportado_1, /*[ConfirmeValidators.numberValidator]*/],
			telefono_reportado_2: [this.prestadorModel.telefono_reportado_2, /*[ConfirmeValidators.numberValidator]*/],
			es_caja_compensacion: [this.prestadorModel.es_caja_compensacion ?? false],
			numero_certificado: [this.prestadorModel.numero_certificado]
		});

		this.formDatosBasicos.controls.es_caja_compensacion.valueChanges
		.subscribe(value => {
			if(value)
				this.formDatosBasicos.controls.numero_certificado.enable();
			else{
				this.formDatosBasicos.controls.numero_certificado.disable();
				this.formDatosBasicos.controls.numero_certificado.setValue(undefined);
			}
		})

		this.formCambiarContrasena = this.formBuilder.group({
			clave_acceso_anterior: ['', Validators.required],
			contrasenaGroup: this.formBuilder.group({
				clave_acceso: ['', [Validators.required, ConfirmeValidators.passwordValidator]],
				clave_acceso_confirmacion: ['', Validators.required]
			}, { validator: ConfirmeValidators.childrenEqual }),
		});
	}

	actualizarDatos(): void {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = '¿Está seguro de guardar los cambios realizados?';
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then((resultado) => {
			this.activeModal.close({ data: this.formDatosBasicos.value, opc: 1 });
		});
	}

	cambiarContrasena(): void {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = '¿Está seguro de guardar los cambios realizados?';
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then((resultado) => {
			this.activeModal.close({ data: { ...this.formCambiarContrasena.value, ...this.formCambiarContrasena.value.contrasenaGroup }, opc: 2 });
		});
	}
	onDismiss() {
		if(this.closeable){
			this.modalService.dismissAll();
		}else{

			this.dataSharedService.sharedData({
				close: true
			});
		}
	}
}
